import { render, staticRenderFns } from "./ErrorListByGateway.vue?vue&type=template&id=ca1500c8&scoped=true&"
import script from "./ErrorListByGateway.vue?vue&type=script&lang=js&"
export * from "./ErrorListByGateway.vue?vue&type=script&lang=js&"
import style0 from "./ErrorListByGateway.vue?vue&type=style&index=0&id=ca1500c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1500c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VPagination,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1500c8')) {
      api.createRecord('ca1500c8', component.options)
    } else {
      api.reload('ca1500c8', component.options)
    }
    module.hot.accept("./ErrorListByGateway.vue?vue&type=template&id=ca1500c8&scoped=true&", function () {
      api.rerender('ca1500c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/pages/ErrorListByGateway.vue"
export default component.exports